import { z } from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { zPercentage } from 'utils/zod'
import { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'

const basicSettingsSchema = z.object({
  customizeRefresherBasicSettingsEnabled: z.boolean().default(false),
  desktopAdThreshold: zPercentage.default(80),
  desktopMonitorUserScrollEnabled: z.boolean().default(false),
  desktopRefreshInterval: z.number().min(0).max(MAX_SAFE_GQL_INTEGER).default(30),
  mobileAdThreshold: zPercentage.default(80),
  mobileMonitorUserScrollEnabled: z.boolean().default(false),
  mobileRefreshInterval: z.number().min(0).max(MAX_SAFE_GQL_INTEGER).default(30),
})

export const schema = z.object({
  basicSettings: basicSettingsSchema.optional(), // feature flag 'yp2827ControlingRefreshParamsOnAdUnitLevel'
  id: z.string(),
  refresherEnabled: z.boolean(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  adUnitRefresher,
  id,
  refresherEnabled,
}: AdUnitForForm): Schema => ({
  basicSettings: adUnitRefresher
    ? {
        customizeRefresherBasicSettingsEnabled:
          adUnitRefresher.customizeRefresherBasicSettingsEnabled,
        desktopAdThreshold: adUnitRefresher.desktopAdThreshold,
        desktopMonitorUserScrollEnabled: adUnitRefresher.desktopMonitorUserScrollEnabled,
        desktopRefreshInterval: adUnitRefresher.desktopRefreshInterval,
        mobileAdThreshold: adUnitRefresher.mobileAdThreshold,
        mobileMonitorUserScrollEnabled: adUnitRefresher.mobileMonitorUserScrollEnabled,
        mobileRefreshInterval: adUnitRefresher.mobileRefreshInterval,
      }
    : undefined,
  id,
  refresherEnabled,
})
